import React from "react";

export function LabelText({ label, value="" }: { label: string, value?: string}) {
    return (
        <div className="grid grid-cols-1">
            <label className="basic-form-label">
                <span>{label}</span>
            </label>
            <label className="basic-form-value-text ml-2">
                <span>{value}</span>
            </label>
        </div>
    );
}